/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountLoyaltyTileViewProps } from './account-loyalty-tile';

const AccountLoyaltyTileView: React.FC<IAccountLoyaltyTileViewProps> = props => {
    const { AccountLoyaltyTile, heading, description, links } = props;

    return (
        <Module {...AccountLoyaltyTile}>
            {heading}
            {description}
            {links}
        </Module>
    );
};

export default AccountLoyaltyTileView;
